import { Component, OnInit } from "@angular/core";

import { TreeNode } from "primeng/api";
import { ScheduleModel } from "../../models/schedule.model";
import { ScheduleService } from "../../services/schedule.service";
import { SubScheduleModel } from "../../models/subschedule.model";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService, ConfirmationService } from "primeng/api";
import { MasterMappingHeadersService } from "../../services/masterMappingHeaders.service";
import { PeriodService } from "../../services/period.service";
import { Sharedservice } from "./../../shared-components/shared.service";
import { CoverIndexService } from "../../services/coverindex.service";
import { environment } from "../../../environments/environment";
import { MasterHelpModel } from "../../models/MasterHelp.model";
import { MasterHelpService } from "../../services/masterhelp.service";
import {
  severitymessage,
  SchedulesComponentmessage,
  FunctionalityNames,
  LanguageConstants,
} from "../../shared-components/constant";
import { UserModel } from "../../models/user.model";
import { UserService } from "../../services/user.service";
import { MonthService } from "./../../services/month.service";
import { MasterPeriodIdentifierService } from "./../../services/masterPeriodIdentifier.service";
import { MonthModel } from "../../models/month.model";
import { MasterPeriodIdentifierModel } from "../../models/masterPeriodIdentifier.model";
import { EngagementService } from "../../services/engagement.service";
import { FlatfileService } from "src/app/services/flatfile.service";
import { EngagementModel } from "../../models/engagement.model";
import { AuditingService } from "../../services/auditing.service";
import { saveAs } from "file-saver";
import { Daiseydashboard } from "src/app/services/daiseydashboard.service";
import { EngagementSchedule } from "../../models/EngagementSchedule.model";
import { SaveScheduleData } from "../../models/SaveScheduleData.model";
import { NGXLogger } from "ngx-logger";
import { WebJobQueueService } from "src/app/services/webjobqueue.service";
import { WebJobQueueModel } from "src/app/models/webJobQueue.model";
import { ErrorPopUpModel } from "../../models/errorpopup.model";
import { EngagementScheduleEntityMapping } from "src/app/models/engagementScheduleEntityMapping";
import { InfraService } from "src/app/services/infra.service";
import { BusinessTemplate } from "src/app/enums/business-template.enum";
import { RegionsEnum } from "src/app/enums/regions.enum";
import { AccountingCalendarEnum } from "src/app/enums/accounting-calendar.enum";
import { MasterSchedule } from "src/app/enums/masterschedule.enum";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { LanguageHelperService } from "src/app/services/language.helper.service";
import { DatabookVersionEnum } from "../../enums/databook-version.enum";
import { DatabookLanguage } from "../../enums/databook-language.enum";
import { AppConfigurationService } from "./../../services/appConfiguration.service";
import { AppConfigurationsModel } from "./../../models/appConfigurations.model";
import { Observable } from "rxjs";
@Component({
  selector: "app-schedules",
  templateUrl: "./schedules.component.html",
  styleUrls: ["./schedules.component.css"],
})
export class SchedulesComponent implements OnInit {
  engagementId = +this.route.snapshot.paramMap.get("id");
  files: ScheduleModel[] = [];
  filterworkallocSelectedCheckbox: ScheduleModel[] = [];
  selectedIds: any[] = [];
  scheduleId: any[] = [];
  tfiles: TreeNode = {};
  Id = true; // Set Hidden field
  SubScheduleId = true;
  scheduleselectall = false;
  selectedSceduleIds: any[] = [];
  selectedEngagementSceduleIds: EngagementSchedule[] = [];
  selectedScheduleEntityMappingIds: EngagementScheduleEntityMapping[] = [];
  savescheduleData: SaveScheduleData;
  selectedHeader: any[] = [];
  isEngagementReadOnly: boolean = false;
  maps: any;
  optionSelectedMapping = 0;
  sourcefile: any[] = [];
  standMap: any[] = [];
  subschedule: SubScheduleModel[] = [];
  show = false;
  checked: boolean;
  subchecked: SubScheduleModel;
  MappingId: number;
  databookTypeValue: number;
  selectedSceduleIds1: any[] = [];
  mappingdata_selectedSceduleIds: any[] = [];
  loadspinner = false;
  loadspinner_upload = false;
  loadspinnerflatfile = false;
  downloadenable = true;
  databook: any;
  uploaddatabook = false;
  downloadDatabookWithPrompt = false;
  timeOutHandler: NodeJS.Timer;
  private loggedInUserId: number;
  months: any[];
  tomonths: any;
  displayForecastPeriod = false;
  isForecastAvailable = 0;
  fromForecastMonth = 0;
  fromForecastYear: any;
  fromMonth = 0;
  fromMonthValue: any;
  fromyear: any;
  toMonth = 0;
  toyear: any;
  monthyear: any[] = [];
  Years: any[];
  public fiscalYearMonth: any;
  FiscalFromMon: any;
  isdisabled = false;
  original = 2;
  standardizedMapping = 8;
  private IsPnP: boolean;
  qe = 1;
  wc = 4;
  flatfileName = "";
  private configUrl: string;
  databookType = "";
  pl1bs1Disabled = false;
  engagementName = "";
  amountInMultiples: any;
  isTempFlatfileUploaded: number;
  daiseyDashboardName = "";
  loadspinnerdaiseydashboard = false;
  loadspinnerPBIflatfile = false;
  loadspinner_data = false;
  isLocalCopyUploaded = false;
  hardcodedDisabled = false;
  mappingLevelId = 8;
  isTimeIntervalInProgressFlatFileDownload = false;
  isTimeIntervalInProgressPowerBiFlatFileDownload = false;
  timeOutHandlerFlatFileDownload: NodeJS.Timer;
  timeOutHandlerPowerBiFlatFileDownload: NodeJS.Timer;
  flatFileDownloadWebJobQueueId: number;
  isTimeIntervalInProgress = false;
  webJobQueueId: number;
  powerBiflatFileDownloadWebJobQueueId: number;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  isAllScheduleUnCheck = false;
  private selectedTemplate: number;
  notificationDisplay = false;
  plMappingData: any[];
  plOnlyEntityData: any[] = [];
  plOnlyParentEntityData: any[] = [];
  bsOnlyEntityData: any[] = [];
  bsOnlyParentEntityData: any[] = [];
  bsMappingData: any[];
  enableForecastDates: boolean;
  isPLAccountMappedToStdMapping = false;
  isBSAccountMappedToStdMapping = false;
  isEntityPresent = false;
  versionType = 1; // 1 is online and 2 is offline (marcro enabled version)
  isEqual12Month = false;
  isEqualP13Month = false;
  isPLMappingOptionSelected = false;
  isBSMappingOptionSelected = false;
  isPLEntityOptionSelected = false;
  isBSEntityOptionSelected = false;
  isFirstTimeSchedule = false;
  isDataTabLinkdisabled = false;
  isGenDatabookInProgress = false;
  confirmdisplay = false;
  confirmgeneratedisplay = false;
  confirmgeneratedisplaydataTab = false;
  accountCalendarId = 0;
  regionId = 0;
  previousStep: string;
  langCode: string;
  currLangTranslation: any;
  db_langCode: string;
  db_currLangTranslation: any;
  isDynamicDatabook = "false";
  public engagement: EngagementModel;
  displayStaticDynamicSelection = false;
  disableOfflineForNonEnglish = false;
  disablePowerBI = false;
  disableOfflineUploadForSpanish = false;
  disablePowerPivotUpload = false;
  disableDatabookType = false;
  disableDatabookOption = false;
  displayPowerPivotOption = false;
  displayTypeOfDatabook = true;
  disableGenerateButton = false;
  public IsCustomizedEng: boolean;

  engagementData: EngagementModel = new EngagementModel();

  constructor(
    private router: Router,
    private infraService: InfraService,
    private schedule: ScheduleService,
    private appConfigService: AppConfigurationService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private mastermapping: MasterMappingHeadersService,
    private periodService: PeriodService,
    public sharedService: Sharedservice,
    private coverIndexService: CoverIndexService,
    private confirmationService: ConfirmationService,
    private userService: UserService,
    private monthService: MonthService,
    private engagementService: EngagementService,
    private auditingService: AuditingService,
    private flatfileService: FlatfileService,
    private daisedashboard: Daiseydashboard,
    private logger: NGXLogger,
    private webJobQueueService: WebJobQueueService,
    private masterPeriodIdentifierService: MasterPeriodIdentifierService,
    private translateService: TranslateService,
    private http: HttpClient,
    private languageHelper: LanguageHelperService
  ) {
    this.checked = false;
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.infraService.infraDetails$.subscribe((data) => {
      if (data !== undefined) {
        this.configUrl =
          data.WebEndPoint1 + "filedownload/dataBook/" + this.engagementId;
        this.databookType = "pl1bs1";
        this.selectedTemplate = +localStorage.getItem(
          "currentEngagementTemplateId" + data.InfraId + this.engagementId
        );
        this.regionId = data.InfraId;
      }
    });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];

    if (this.versionType == DatabookVersionEnum.PowerPivot) {
      this.displayForecastPeriod = true;
    }

    // this.enableForecastDates = true;
    this.isTempFlatfileUploaded = this.sharedService.getLocalStorageValueByName(
      "isTempFlatfileUploaded" + this.engagementId + this.regionId
    );
    this.engagementService
      .getEngagement(this.engagementId)
      .subscribe((data: EngagementModel) => {
        this.IsCustomizedEng = data.IsCustomizedEngagement;

        this.IsPnP = data.IsPnP;
      });

    if (this.isTempFlatfileUploaded === 1) {
      if (
        this.engagementService.engModel.IsPnP &&
        this.engagementService.engModel.TemplateId != 3 && this.engagementService.engModel.AccCalendarId === 1
      )
        this.sharedService.setactiveindex(5);
      else {
        this.sharedService.setactiveindex(4);
      }
    } else {
      this.sharedService.setactiveindex(7);
    }
    this.LoadData();
    this.previousStep = this.currLangTranslation.actionButtons.previousStep;
    this.onLoadForecast();
    this.onSelectForecastRadio();

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.langCode = langEvent.lang;
        this.currLangTranslation = langEvent.translations;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        this.getMonth();
        this.getSchedules();
      }
    );
  }

  private LoadData(): void {
    this.getEngagement();
    this.LoadMasterMapping();
    this.checkDatabookalreadyExists();
    this.getUserData();
    this.checkDuplicateAccountDescription();
  }

  private getEngagement(): void {
    this.engagementService.getEngagement(this.engagementId).subscribe(
      (data: EngagementModel) => {
        if (this.db_langCode === this.langCode) {
          this.db_currLangTranslation = JSON.parse(
            JSON.stringify(this.currLangTranslation)
          );
        } else {
          this.http
            .get(`../assets/i18n/${data.LanguageCode}.json`)
            .subscribe((i18n) => {
              this.db_currLangTranslation = i18n;
            });
        }
        this.engagementName = data.EngagementName;
        this.accountCalendarId = data.AccCalendarId;
        //this.regionId = data.RegionId;  commented for powerbi file name date format issue - by Girish
        this.selectedTemplate = data.TemplateId;
        this.fiscalYearMonth = data.FiscalYearMonth;
        this.mappingLevelId =
          data.MappingLevel === null || data.MappingLevel === 0
            ? 8
            : data.MappingLevel;
        this.versionType =
          data.DatabookVersion === null || data.DatabookVersion === 0
            ? DatabookVersionEnum.Online
            : data.DatabookVersion;
        //this.versionType = this.versionType;
        //   data.IsCustomizedEngagement === true
        //     ? DatabookVersionEnum.Online
        //     : this.versionType;
        this.databookType = data.Type == null ? "pl1bs1" : data.Type;
        this.databookType =
          data.IsCustomizedEngagement === true ? "datatab" : this.databookType;
        this.isLocalCopyUploaded =
          data.IsLocalCopyUploaded == null ? false : data.IsLocalCopyUploaded;
        this.selectedTemplate = data.TemplateId ? data.TemplateId : 0;
        this.amountInMultiples = data.AmountInMultiples;
        this.isDynamicDatabook = data.IsDynamicDatabook ? "true" : "false";
        this.isForecastAvailable = data.IsForecastIncl ? 1 : 0;
        this.enableForecastDates = data.IsForecastIncl;
        this.fromForecastMonth = data.ForecastMonth ? data.ForecastMonth : 0;
        this.fromForecastYear = data.ForecastYear ? data.ForecastYear : 0;
        this.engagementData = data;
        if (this.isDynamicDatabook === "true") {
          this.databookType = "datatab";
          this.disableDatabookType = true;
        }
        if (
          this.accountCalendarId == 1 &&
          this.versionType == DatabookVersionEnum.PowerPivot
        ) {
          this.displayForecastPeriod = true;
        }
        if (
          data.LanguageId === DatabookLanguage.SpanishLatinAmerica ||
          (data.LanguageId === DatabookLanguage.Japanese &&
            this.regionId === RegionsEnum.APAC)
        ) {
          this.disableOfflineForNonEnglish = true;
          this.disablePowerBI = true;
        }
        if (
          data.LanguageId === DatabookLanguage.SpanishLatinAmerica &&
          this.versionType === DatabookVersionEnum.Offline
        ) {
          this.disableOfflineUploadForSpanish = true;
        }
        if (this.accountCalendarId === AccountingCalendarEnum.P12) {
          this.displayPowerPivotOption = true;
        }

        if (this.versionType === DatabookVersionEnum.PowerPivot) {
          this.displayTypeOfDatabook = false;
          this.disablePowerPivotUpload = true;
          this.displayForecastPeriod = true;
        }

        if (
          this.accountCalendarId === AccountingCalendarEnum.P12 ||
          this.accountCalendarId === AccountingCalendarEnum.P445 ||
          this.accountCalendarId === AccountingCalendarEnum.P454 ||
          this.accountCalendarId === AccountingCalendarEnum.P544
        ) {
          this.getMonth();
        } else if (this.accountCalendarId === AccountingCalendarEnum.P13) {
          this.getP13Periods();
        }
        this.getMonthYear();
      },
      (error) => {
        this.logger.info(
          "--------error logged in schedules.component.getEngagement()----------" +
          error
        );
      }
    );
  }

  private checkDuplicateAccountDescription(): void {
    this.schedule.checkDuplicateAccountDescription(this.engagementId).subscribe(
      (response: boolean) => {
        if (response === true) {
          this.isDataTabLinkdisabled = response;
          this.databookType = "pl1bs1";
        }
      },
      (error) => {
        this.logger.info(
          "--------error logged in schedules.component.checkDuplicateAccountDescription()----------" +
          error
        );
      }
    );
  }

  // RadioButton selection change
  onSelectionRadio(id) {
    this.mappingLevelId = id;
    for (let i = 0; i <= this.files.length - 1; i++) {
      this.files[i].MappingHeaderId = id;
    }
  }

  //On Submit Forecast Validation

  onSubmitForecastValidation() {
    if (this.isForecastAvailable == 1) {
      if (
        this.fromForecastMonth == null ||
        this.fromForecastMonth == 0 ||
        this.fromForecastYear == "null" ||
        this.fromForecastYear == ""
      ) {
        this.loadspinner_data = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.schedulesComponentmessage.ErrorMessage
              .SelectYearInPeriod,
          sticky: true,
          closable: true,
        });
        return false;
      }
    }
  }

  //Code for validate forecast month selection
  onLoadForecast() {
    const toDate = new Date();
    var monthval = toDate.getMonth();
    var currentYear = toDate.getFullYear();
    if (
      this.fromForecastMonth == null ||
      this.fromForecastMonth == undefined ||
      this.fromForecastMonth == 0
    ) {
      this.fromForecastMonth = monthval + 1;
    }
    if (
      this.fromForecastYear == null ||
      this.fromForecastYear == undefined ||
      this.fromForecastYear == 0
    ) {
      this.fromForecastYear = currentYear;
    }
    this.onFYChange();
  }
  //Validate Forecast year selection
  onFYChange() {
    this.disableGenerateButton = false;
    if (this.fromForecastYear == this.fromyear) {
      if (this.fromForecastMonth < this.fromMonth) {
        this.disableGenerateButton = true;
      }
    }

    if (this.fromForecastYear == this.toyear) {
      if (this.fromForecastMonth > this.toMonth) {
        this.disableGenerateButton = true;
      }
    }

    if (
      this.fromForecastYear > this.toyear ||
      this.fromForecastYear < this.fromyear
    ) {
      this.disableGenerateButton = true;
    }
    if (this.isForecastAvailable == 1 && this.fromForecastMonth == 0) {
      this.disableGenerateButton = true;
    }
    if (this.isForecastAvailable == 0) {
      this.disableGenerateButton = false;
    }
    if (this.versionType != DatabookVersionEnum.PowerPivot) {
      this.disableGenerateButton = false;
      //this.enableForecastDates = false;
    }
    if (
      this.isForecastAvailable == 1 &&
      this.versionType == DatabookVersionEnum.PowerPivot
    ) {
      if (this.disableGenerateButton == true) {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.schedulesComponentmessage.ErrorMessage
              .SelectYearInPeriod,
          sticky: true,
          closable: true,
        });
        return false;
      }
    }
  }
  //Enable and disable drop downs
  onSelectForecastRadio() {
    if (this.isForecastAvailable == 1) {
      this.enableForecastDates = true; //Enable forecast date drop downs
      this.onLoadForecast(); // load default values on enabling drop downs.
    } else {
      this.enableForecastDates = false;
      this.disableGenerateButton = false;
      this.fromForecastMonth = 0;
      this.fromForecastYear = 0;
    }
  }

  private getMonth(): void {
    this.loadspinner_data = true;
    this.isdisabled = true;
    this.monthService.getAllMonths().subscribe(
      (response: MonthModel[]) => {
        this.months = response;

        this.months.forEach((element) => {
          element.Month = this.languageHelper.convertMonthToLocale(
            this.langCode,
            element.Month
          );
        });

        if (this.fiscalYearMonth == 12) {
          this.FiscalFromMon = this.months.filter((x) => x.Id == 1);
        } else {
          //this.fiscalYearMonth = this.fiscalYearMonth + 1;
          this.FiscalFromMon = this.months.filter(
            (x) => x.Id == this.fiscalYearMonth + 1
          );
        }
        this.fromMonth = this.FiscalFromMon[0].Id;
        this.fromMonthValue = this.languageHelper.convertMonthToLocale(
          this.langCode,
          this.FiscalFromMon[0].Month
        );
      },
      (error) => {
        this.loadspinner_data = false;
        this.logger.info(
          "--------error logged in schedules.component.getMonth()----------" +
          error
        );
      }
    );
  }

  private getP13Periods(): void {
    this.loadspinner_data = true;
    this.isdisabled = true;
    this.masterPeriodIdentifierService.getP13Periods().subscribe(
      (response: MasterPeriodIdentifierModel[]) => {
        this.months = response;
        // Take always first period irrespective of fiscal YearMonth
        this.FiscalFromMon = response.filter((x) => x.Id == 1);
        this.fromMonth = this.FiscalFromMon[0].Id;
        this.fromMonthValue = this.FiscalFromMon[0].Month;
      },
      (error) => {
        this.loadspinner_data = false;
        this.logger.info(
          "--------error logged in schedules.component.getMonth()----------" +
          error
        );
      }
    );
  }

  private getYears(): void {
    let isFromYearPresent = false;
    const year = new Date().getFullYear() + 5; // For adding future 5 years
    const range = [];
    const firstYear = year - 10;
    for (let i = year; i > year - 11; i--) {
      range.push(i);
      if (this.fromyear === i) {
        isFromYearPresent = true;
      }
    }

    if (isFromYearPresent === false) {
      // If period fromYear is not present then set first year as fromYear.
      this.fromyear = firstYear;
    }
    this.Years = range;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  // Checkbox selection
  scheduleSelectAll() {
    const selected = this.scheduleselectall;
    if (this.scheduleselectall === false) {
      this.isAllScheduleUnCheck = true;
    } else {
      this.isAllScheduleUnCheck = false;
    }

    this.files.filter((r) => {
      r.isChecked = selected;
      if (
        this.fromMonth !== null &&
        this.fromMonth !== 0 &&
        this.fromyear !== null &&
        this.fromyear !== "" &&
        this.toMonth !== null &&
        this.toMonth !== 0 &&
        this.toyear !== null &&
        this.toyear !== ""
      ) {
        // here Id==5 => "CF - Free cash flow"
        // Check if user select all schedules then verify date range , if date range is 12 months then disable and uncheck "CF -
        // Free cash Flow" checkbox.
        if (
          this.accountCalendarId === AccountingCalendarEnum.P12 ||
          this.accountCalendarId === AccountingCalendarEnum.P445 ||
          this.accountCalendarId === AccountingCalendarEnum.P454 ||
          this.accountCalendarId === AccountingCalendarEnum.P544
        ) {
          if (
            (r.Id === MasterSchedule.CFFreeCashFlow_Template1 ||
              r.Id === MasterSchedule.CFFreeCashFlow_Template2 ||
              r.Id === MasterSchedule.CFFreeCashFlow_Template3) &&
            (this.toyear - this.fromyear) * 12 +
            (this.toMonth - this.fromMonth + 1) ===
            12
          ) {
            r.isChecked = false;
            this.isEqual12Month = true;
          }
        } else if (this.accountCalendarId === AccountingCalendarEnum.P13) {
          if (
            (r.Id === MasterSchedule.CFFreeCashFlow_Template1 ||
              r.Id === MasterSchedule.CFFreeCashFlow_Template2 ||
              r.Id === MasterSchedule.CFFreeCashFlow_Template3) &&
            (this.toyear - this.fromyear) * 13 +
            (this.toMonth - this.fromMonth + 1) ===
            13
          ) {
            r.isChecked = false;
            this.isEqualP13Month = true;
          }
        }
      }
    });
  }

  private getSchedules(): void {
    this.loadspinner_data = true;
    const flag = false;

    this.schedule
      .getSchedules(
        this.engagementId,
        this.fromMonth,
        this.fromyear,
        this.toMonth,
        this.toyear,
        this.isDynamicDatabook === "false" ? false : true
      )
      .subscribe(
        (data: any) => {
          this.plMappingData = [];
          this.bsMappingData = [];
          this.plOnlyEntityData = [];
          this.bsOnlyEntityData = [];
          this.plOnlyParentEntityData = [];
          this.bsOnlyParentEntityData = [];
          this.files = data.filesData;
          this.plMappingData = data.plMappingData;
          this.bsMappingData = data.bsMappingData;
          this.plOnlyEntityData = data.plOnlyEntityData;
          this.bsOnlyEntityData = data.bsOnlyEntityData;
          this.disableDatabookOption = data.disableDatabookOption;
          if (this.versionType === DatabookVersionEnum.PowerPivot) {
            this.displayForecastPeriod = true;
          }
          if (
            data.plOnlyEntityData.length > 0 ||
            data.bsOnlyEntityData.length > 0
          ) {
            if (this.accountCalendarId === AccountingCalendarEnum.P12) {
              this.displayStaticDynamicSelection = true;
            }
          }
          this.isBSAccountMappedToStdMapping = false;
          this.isPLAccountMappedToStdMapping = false;

          this.files.forEach((element) => {
            switch (element.Title) {
              case "QE- Lead quality of earnings":
                element.Title =
                  this.currLangTranslation.step8.selectSchedules.fileItems.qe;
                break;
              case "Lead PF-PL":
                element.Title =
                  this.currLangTranslation.step8.selectSchedules.fileItems.leadPFPL;
                break;
              case "PL - Lead profit & loss and supporting schedules":
                element.Title =
                  this.currLangTranslation.step8.selectSchedules.fileItems.plLeadProfit;
                break;
              case "BS - Lead balance sheet and supporting schedules":
                element.Title =
                  this.currLangTranslation.step8.selectSchedules.fileItems.BSLeadProfit;
                break;
              case "WC - Working capital":
                element.Title =
                  this.currLangTranslation.step8.selectSchedules.fileItems.wc;
                break;
              case "CF - Free cash flow":
                element.Title =
                  this.currLangTranslation.step8.selectSchedules.fileItems.cf;
                break;
              default:
                break;
            }
          });

          this.files
            .filter((w) => w.IsSaved == true)
            .forEach((element) => {
              this.selectedIds.push({
                SubScheduleId: element.SubScheduleId,
                MappingHeaderId: element.MappingHeaderId,
                IsSaved: element.IsSaved,
              });
              if (element.EngagementId === 0) {
                this.isFirstTimeSchedule = true;
              } else {
                this.isFirstTimeSchedule = false;
              }
            });

          this.plOnlyEntityData.forEach((element) => {
            this.isEntityPresent = true;
            if (this.isFirstTimeSchedule === true) {
              element.IsChecked = 1;
            }

            if (
              !this.plOnlyParentEntityData.some(
                (x) => x.Entity1Id === element.Entity1Id
              )
            ) {
              element.Entity1IdIsChecked = element.IsChecked;
              this.plOnlyParentEntityData.push(element);
            }

            if (element.IsChecked === true || element.IsChecked === 1) {
              this.isPLEntityOptionSelected = true;
            }
          });

          this.bsOnlyEntityData.forEach((element) => {
            this.isEntityPresent = true;
            if (this.isFirstTimeSchedule === true) {
              element.IsChecked = 1;
            }
            if (
              !this.bsOnlyParentEntityData.some(
                (x) => x.Entity1Id === element.Entity1Id
              )
            ) {
              element.Entity1IdIsChecked = element.IsChecked;
              this.bsOnlyParentEntityData.push(element);
            }

            if (element.IsChecked || element.IsChecked === 1) {
              this.isBSEntityOptionSelected = true;
            }
          });

          this.bsMappingData.forEach((element) => {
            if (
              element.IsMappingSelected === true ||
              element.IsMappingSelected === 1
            ) {
              if (this.isFirstTimeSchedule === true) {
                element.IsChecked = 1;
              }
              this.isBSAccountMappedToStdMapping = true;
              if (element.IsChecked || element.IsChecked === 1) {
                this.isBSMappingOptionSelected = true;
              }
              if (this.isDynamicDatabook === "true") {
                element.IsChecked = 0;
                this.isBSMappingOptionSelected = false;
              }
            }
          });

          this.plMappingData.forEach((element) => {
            if (
              element.IsMappingSelected === true ||
              element.IsMappingSelected === 1
            ) {
              if (this.isFirstTimeSchedule === true) {
                element.IsChecked = 1;
              }
              this.isPLAccountMappedToStdMapping = true;
              if (element.IsChecked || element.IsChecked === 1) {
                this.isPLMappingOptionSelected = true;
              }
              if (this.isDynamicDatabook === "true") {
                element.IsChecked = 0;
                this.isPLMappingOptionSelected = false;
              }
            }
          });

          if (this.selectedIds.length == 0) {
            this.files
              .filter((r) => {
                return r.DefaultSelected == true;
              })
              .map((o) => {
                o.isChecked = true;
              });
          } else {
            //if (this.files.some(x => x.MappingTitle === 'Standardized Mapping')) {
            //  this.mappingLevelId = 8;
            //} else if (this.files.some(x => x.MappingTitle === 'Mapping 2')) {
            //  this.mappingLevelId = 2;
            //}

            this.files
              .filter((r) => {
                return r.IsSaved == true;
              })
              .map((o) => {
                o.isChecked = true;
              });

            if (
              this.fromMonth !== null &&
              this.fromMonth !== 0 &&
              this.fromyear !== null &&
              this.fromyear !== "" &&
              this.toMonth !== null &&
              this.toMonth !== 0 &&
              this.toyear !== null &&
              this.toyear !== ""
            ) {
              this.files.filter((f) => {
                // here Id==5 => "CF - Free cash flow"
                // Check if range difference is 12 months then disable and uncheck "CF - Free cash flow" checkbox.
                if (this.IsCustomizedEng === true) {
                  if (
                    f.Id === 5 ||
                    f.Id === 11 ||
                    f.Id === 16 ||
                    f.Id === 10 ||
                    f.Id === 4 ||
                    f.Id === 15 ||
                    f.Id === 1 ||
                    f.Id === 7 ||
                    f.Id === 12 ||
                    f.Id === 6
                  ) {
                    f.isChecked = false;
                  }
                }
                if (
                  this.accountCalendarId === AccountingCalendarEnum.P12 ||
                  this.accountCalendarId === AccountingCalendarEnum.P445 ||
                  this.accountCalendarId === AccountingCalendarEnum.P454 ||
                  this.accountCalendarId === AccountingCalendarEnum.P544
                ) {
                  if (
                    (f.Id === MasterSchedule.CFFreeCashFlow_Template1 ||
                      f.Id === MasterSchedule.CFFreeCashFlow_Template2 ||
                      f.Id === MasterSchedule.CFFreeCashFlow_Template3) &&
                    (this.toyear - this.fromyear) * 12 +
                    (this.toMonth - this.fromMonth + 1) ===
                    12
                  ) {
                    f.isChecked = false;
                    this.isEqual12Month = true;
                  } else {
                    this.isEqual12Month = false;
                  }
                } else if (
                  this.accountCalendarId === AccountingCalendarEnum.P13
                ) {
                  if (
                    (f.Id === MasterSchedule.CFFreeCashFlow_Template1 ||
                      f.Id === MasterSchedule.CFFreeCashFlow_Template2 ||
                      f.Id === MasterSchedule.CFFreeCashFlow_Template3) &&
                    (this.toyear - this.fromyear) * 13 +
                    (this.toMonth - this.fromMonth + 1) ===
                    13
                  ) {
                    f.isChecked = false;
                    this.isEqualP13Month = true;
                  } else {
                    this.isEqualP13Month = false;
                  }
                }
              });
            }
          }

          this.loadspinner_data = false;
        },
        (error) => {
          this.loadspinner_data = false;
          this.logger.info(
            "--------error logged in schedules.component.getSchedules()----------" +
            error
          );
        }
      );
  }

  private getMonthYear(): void {
    this.loadspinner_data = true;
    this.schedule.getMonthYear(this.engagementId).subscribe(
      (data: any) => {
        this.monthyear = data;
        if (this.fromMonth === 0) {
          this.fromMonth = data.FromMonth;
        }
        this.fromyear = data.FromYear;
        this.toMonth = data.ToMonth;
        this.toyear = data.ToYear;
        this.getYears();
        this.onDateChange();
      },
      (error) => {
        this.loadspinner_data = false;
        this.logger.info(
          "--------error logged in schedules.component.getMonthYear()----------" +
          error
        );
      }
    );
  }

  // To Load Batch
  LoadMasterMapping() {
    this.loadspinner_data = true;
    this.mastermapping.getMasterMappingHeaders().subscribe(
      (data) => {
        this.maps = data.filter(
          (x) =>
            x.title != "Mapping 1" &&
            x.title != "Mapping 3" &&
            x.title != "Mapping 4" &&
            x.title != "Mapping 5" &&
            x.title != "Mapping 6" &&
            x.title != "Mapping 7"
        );
        this.maps
          .filter((w) => w.title == "Mapping 2")
          .forEach((element) => {
            this.sourcefile.push({ Id: element.Id });
          });
        this.maps
          .filter((w) => w.title == "Standardized Mapping")
          .forEach((element) => {
            this.standMap.push({ Id: element.Id });
          });
      },
      (error) => {
        this.loadspinner_data = false;
        this.logger.info(
          "--------error logged in schedules.component.LoadMasterMapping()----------" +
          error
        );
      }
    );
  }

  // To Load Batch
  LoadPeriods() {
    this.periodService.getEngagementPeriods(this.engagementId).subscribe(
      (data) => { },
      (error) => {
        this.logger.info(
          "--------error logged in schedules.component.LoadPeriods()----------" +
          error
        );
      }
    );
  }

  public getUserData() {
    this.userService.cast.subscribe(
      (userData: UserModel) => {
        if (userData.Id !== undefined) {
          this.loggedInUserId = userData.Id;
        }
      },
      (error) => {
        this.logger.info(
          "--------error logged in schedules.component.getUserData()----------" +
          error
        );
      }
    );
  }

  closeEventworkallocation($event) {
    this.confirmdisplay = $event;
  }

  previousButton() {
    this.confirmdisplay = false;
    this.router.navigate([
      "/engagement/",
      this.engagementId,
      "performdatacheck",
    ]);
  }

  OverwriteEvent($event) {
    this.confirmgeneratedisplay = false;
    this.downloadDatabookWithPrompt = false;
    this.updateDatabook(false);
    this.selectedEngagementSceduleIds = [];
  }

  UpdateDataTabEvent($event) {
    this.confirmgeneratedisplay = false;
    this.downloadDatabookWithPrompt = false;
    this.updateDatabook(true);
    this.selectedEngagementSceduleIds = [];
  }

  DataTabUpdate1Event($event) {
    this.confirmgeneratedisplaydataTab = false;
    this.LoadData();
  }

  updateCoverIndexDataTab() {
    this.confirmgeneratedisplaydataTab = true;
  }

  updateCoverIndex(
    databookType = false,
    isSavePowerBISchedule: boolean,
    isDatabookUpload: boolean = false
  ) {
    if (!this.isGenDatabookInProgress) {
      if (databookType == false) {
        this.isGenDatabookInProgress = true;
      }
      if (!isSavePowerBISchedule) {
        let isNewVersion = true;
        isNewVersion =
          this.versionType === DatabookVersionEnum.Online ? true : false;
        if (isNewVersion) {
          this.loadspinner = false;
        } else {
          this.loadspinner = true;
        }

        this.coverIndexService.CheckDatabookStatus(this.engagementId).subscribe(
          (data: any) => {
            this.isGenDatabookInProgress = false;
            if (data.status.indexOf("success") >= 0) {
              this.subCoverIndex(
                databookType,
                isSavePowerBISchedule,
                isDatabookUpload
              );
            } else {
              this.loadspinner = false;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
              return false;
            }
          },
          (error) => {
            if (error.status === 400) {
              if (error.error.statusId === 422) {
                // 422 status id means queue is already present for databook generation
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.headerTitle =
                  this.currLangTranslation.severitymessage.notification;
                this.errorModel.displayMessage =
                  this.currLangTranslation.schedulesComponentmessage.ErrorMessage.QueueInProgress;
                this.loadspinner = false;
                return false;
              }
            } else {
              this.logger.info(
                "--------error logged in schedules.component.updateDatabook()----------" +
                error
              );
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
              this.loadspinner = false;
              return false;
            }
          }
        );
      } else {
        this.subCoverIndex(
          databookType,
          isSavePowerBISchedule,
          isDatabookUpload
        );
      }
    } else {
      return false;
    }
  }

  subCoverIndex(
    databookType = false,
    isSavePowerBISchedule: boolean,
    isDatabookUpload: boolean = false
  ) {
    this.selectedEngagementSceduleIds = [];
    this.selectedScheduleEntityMappingIds = [];
    this.confirmgeneratedisplaydataTab = false;
    this.confirmgeneratedisplay = false;
    this.checkDatabookalreadyExists();
    if (
      this.fromMonth == null ||
      this.fromMonth == 0 ||
      this.fromyear == "null" ||
      this.fromyear == "" ||
      this.toMonth == null ||
      this.toMonth == 0 ||
      this.toyear == "null" ||
      this.toyear == ""
    ) {
      this.loadspinner = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage
            .Mandatory,
        sticky: true,
        closable: true,
      });
      return false;
    }
    if (this.fromyear > this.toyear) {
      this.loadspinner = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage
            .YearError,
        sticky: true,
        closable: true,
      });
      return false;
    }
    if (this.fromyear == this.toyear) {
      if (this.fromMonth > this.toMonth) {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.schedulesComponentmessage.ErrorMessage
              .MonthError,
          sticky: true,
          closable: true,
        });
        return false;
      }
    }
    if (
      this.accountCalendarId === AccountingCalendarEnum.P12 ||
      this.accountCalendarId === AccountingCalendarEnum.P445 ||
      this.accountCalendarId === AccountingCalendarEnum.P454 ||
      this.accountCalendarId === AccountingCalendarEnum.P544
    ) {
      if (
        (this.toyear - this.fromyear) * 12 +
        (this.toMonth - this.fromMonth + 1) <
        12
      ) {
        this.loadspinner = false;
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage.LessThan12MonthError;
        return false;
      }
    } else if (this.accountCalendarId === AccountingCalendarEnum.P13) {
      if (
        (this.toyear - this.fromyear) * 13 +
        (this.toMonth - this.fromMonth + 1) <
        13
      ) {
        this.loadspinner = false;
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage.LessThan13MonthError;
        return false;
      }
    }
    if (this.files.filter((w) => w.isChecked === true).length === 0) {
      this.loadspinner = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage
            .ScheduleError,
        sticky: true,
        closable: true,
      });
      return false;
    }

    if (
      this.isPLAccountMappedToStdMapping === false &&
      this.isBSAccountMappedToStdMapping === false
    ) {
      this.loadspinner = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage
            .ScheduleError,
        sticky: true,
        closable: true,
      });
      return false;
    }

    this.files
      .filter((w) => w.isChecked === true)
      .forEach((element) => {
        if (
          (element.Id === MasterSchedule.CFFreeCashFlow_Template1 ||
            element.Id === MasterSchedule.CFFreeCashFlow_Template2 ||
            element.Id === MasterSchedule.CFFreeCashFlow_Template3) &&
          (this.isEqual12Month || this.isEqualP13Month)
        ) {
          // If Lead CF and range is 12 month then do not add CF schedule.
        } else {
          if (this.isPLAccountMappedToStdMapping === true) {
            if (
              element.Id === MasterSchedule.QELeadQualityofEarnings_Template1 ||
              element.Id === MasterSchedule.QELeadQualityofEarnings_Template2 ||
              element.Id === MasterSchedule.LeadPFPL_Template1 ||
              element.Id ===
              MasterSchedule.PLLeadProfitandLossandSupportingSchedules_Template1 ||
              element.Id ===
              MasterSchedule.PLLeadProfitandLossandSupportingSchedules_Template2 ||
              element.Id === MasterSchedule.QELeadQualityofEarnings_Template3 ||
              element.Id ===
              MasterSchedule.PLLeadProfitandLossandSupportingSchedules_Template3
            ) {
              this.selectedEngagementSceduleIds.push({
                EngagementId: this.engagementId,
                ScheduleId: element.Id,
                MappingHeaderId: this.mappingLevelId,
              });
            }
          }

          if (this.isBSAccountMappedToStdMapping === true) {
            if (
              element.Id ===
              MasterSchedule.BSLeadBalanceSheetandsupportingSchedules_Template1 ||
              element.Id ===
              MasterSchedule.BSLeadBalanceSheetandsupportingSchedules_Template2 ||
              element.Id === MasterSchedule.WCWorkingCapital_Template1 ||
              element.Id === MasterSchedule.WCWorkingCapital_Template2 ||
              element.Id === MasterSchedule.CFFreeCashFlow_Template1 ||
              element.Id === MasterSchedule.CFFreeCashFlow_Template2 ||
              element.Id ===
              MasterSchedule.BSLeadBalanceSheetandsupportingSchedules_Template3 ||
              element.Id === MasterSchedule.WCWorkingCapital_Template3 ||
              element.Id === MasterSchedule.CFFreeCashFlow_Template3
            ) {
              this.selectedEngagementSceduleIds.push({
                EngagementId: this.engagementId,
                ScheduleId: element.Id,
                MappingHeaderId: this.mappingLevelId,
              });
            }
          }
        }
      });

    let isAnyBSMappingSelected = false;
    let isAnyPLMappingSelected = false;
    // Check if BS Mapping has some data.
    this.bsMappingData
      .filter((b) => b.IsChecked === true || b.IsChecked === 1)
      .forEach((element) => {
        isAnyBSMappingSelected = true;
        if (
          element.IsMappingSelected === true ||
          element.IsMappingSelected === 1
        ) {
          this.selectedScheduleEntityMappingIds.push({
            EngagementId: this.engagementId,
            ScheduleId: element.ScheduleId,
            EntityId: null,
            StdMappingId: element.MappingId,
          });

          this.bsOnlyParentEntityData.forEach((entity) => {
            if (entity.Entity1IdIsChecked) {
              if (
                entity.Entity2Id !== null &&
                entity.Entity2Id !== undefined &&
                entity.Entity2Id !== 0
              ) {
                this.selectedScheduleEntityMappingIds.push({
                  EngagementId: this.engagementId,
                  ScheduleId: element.ScheduleId,
                  EntityId: entity.Entity2Id,
                  StdMappingId: element.MappingId,
                });
              } else {
                this.selectedScheduleEntityMappingIds.push({
                  EngagementId: this.engagementId,
                  ScheduleId: element.ScheduleId,
                  EntityId: entity.Entity1Id,
                  StdMappingId: element.MappingId,
                });
              }
            }
          });

          this.bsOnlyEntityData.forEach((entity) => {
            if (entity.IsChecked) {
              if (
                entity.Entity2Id !== null &&
                entity.Entity2Id !== undefined &&
                entity.Entity2Id !== 0
              ) {
                if (
                  !this.selectedScheduleEntityMappingIds.some(
                    (x) =>
                      x.EntityId === entity.Entity2Id &&
                      (x.ScheduleId === 3 ||
                        x.ScheduleId === 9 ||
                        x.ScheduleId === 14) &&
                      x.StdMappingId === element.MappingId
                  )
                ) {
                  this.selectedScheduleEntityMappingIds.push({
                    EngagementId: this.engagementId,
                    ScheduleId: element.ScheduleId,
                    EntityId: entity.Entity2Id,
                    StdMappingId: element.MappingId,
                  });
                }
              } else {
                if (
                  !this.selectedScheduleEntityMappingIds.some(
                    (x) =>
                      x.EntityId === entity.Entity1Id &&
                      (x.ScheduleId === 3 ||
                        x.ScheduleId === 9 ||
                        x.ScheduleId === 14) &&
                      x.StdMappingId === element.MappingId
                  )
                ) {
                  this.selectedScheduleEntityMappingIds.push({
                    EngagementId: this.engagementId,
                    ScheduleId: element.ScheduleId,
                    EntityId: entity.Entity1Id,
                    StdMappingId: element.MappingId,
                  });
                }
              }
            }
          });
        }
      });

    // Check if PL Mapping has some data.
    this.plMappingData
      .filter((b) => b.IsChecked === true || b.IsChecked === 1)
      .forEach((element) => {
        isAnyPLMappingSelected = true;
        if (
          element.IsMappingSelected === true ||
          element.IsMappingSelected === 1
        ) {
          if (this.selectedTemplate === BusinessTemplate.Row) {
            // If user is selected "Depreciation and amortization" option then add "D&A COGS , D&A opex and D&A other expense" records in
            // schedule mapping table.
            // 34 - D&A COGS , 48 - D&A opex and 49 - D&A other expense
            if (element.MappingId === 34) {
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: element.ScheduleId,
                EntityId: null,
                StdMappingId: 34,
              });
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: element.ScheduleId,
                EntityId: null,
                StdMappingId: 48,
              });
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: element.ScheduleId,
                EntityId: null,
                StdMappingId: 49,
              });
            } else {
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: element.ScheduleId,
                EntityId: null,
                StdMappingId: element.MappingId,
              });
            }
          } else {
            this.selectedScheduleEntityMappingIds.push({
              EngagementId: this.engagementId,
              ScheduleId: element.ScheduleId,
              EntityId: null,
              StdMappingId: element.MappingId,
            });
          }

          this.plOnlyParentEntityData.forEach((entity) => {
            if (entity.Entity1IdIsChecked) {
              if (
                entity.Entity2Id !== null &&
                entity.Entity2Id !== undefined &&
                entity.Entity2Id !== 0
              ) {
                if (this.selectedTemplate === BusinessTemplate.Row) {
                  if (element.MappingId === 34) {
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity2Id,
                      StdMappingId: 34,
                    });
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity2Id,
                      StdMappingId: 48,
                    });
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity2Id,
                      StdMappingId: 49,
                    });
                  } else {
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity2Id,
                      StdMappingId: element.MappingId,
                    });
                  }
                } else {
                  this.selectedScheduleEntityMappingIds.push({
                    EngagementId: this.engagementId,
                    ScheduleId: element.ScheduleId,
                    EntityId: entity.Entity2Id,
                    StdMappingId: element.MappingId,
                  });
                }
              } else {
                if (this.selectedTemplate === BusinessTemplate.Row) {
                  if (element.MappingId === 34) {
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity1Id,
                      StdMappingId: 34,
                    });
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity1Id,
                      StdMappingId: 48,
                    });
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity1Id,
                      StdMappingId: 49,
                    });
                  } else {
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity1Id,
                      StdMappingId: element.MappingId,
                    });
                  }
                } else {
                  this.selectedScheduleEntityMappingIds.push({
                    EngagementId: this.engagementId,
                    ScheduleId: element.ScheduleId,
                    EntityId: entity.Entity1Id,
                    StdMappingId: element.MappingId,
                  });
                }
              }
            }
          });

          this.plOnlyEntityData.forEach((entity) => {
            if (entity.IsChecked) {
              if (
                entity.Entity2Id !== null &&
                entity.Entity2Id !== undefined &&
                entity.Entity2Id !== 0
              ) {
                if (
                  !this.selectedScheduleEntityMappingIds.some(
                    (x) =>
                      x.EntityId === entity.Entity2Id &&
                      (x.ScheduleId === 2 ||
                        x.ScheduleId === 8 ||
                        x.ScheduleId === 13) &&
                      x.StdMappingId === element.MappingId
                  )
                ) {
                  if (this.selectedTemplate === BusinessTemplate.Row) {
                    if (element.MappingId === 34) {
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity2Id,
                        StdMappingId: 34,
                      });
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity2Id,
                        StdMappingId: 48,
                      });
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity2Id,
                        StdMappingId: 49,
                      });
                    } else {
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity2Id,
                        StdMappingId: element.MappingId,
                      });
                    }
                  } else {
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity2Id,
                      StdMappingId: element.MappingId,
                    });
                  }
                }
              } else {
                if (
                  !this.selectedScheduleEntityMappingIds.some(
                    (x) =>
                      x.EntityId === entity.Entity1Id &&
                      (x.ScheduleId === 2 ||
                        x.ScheduleId === 8 ||
                        x.ScheduleId === 13) &&
                      x.StdMappingId === element.MappingId
                  )
                ) {
                  if (this.selectedTemplate === BusinessTemplate.Row) {
                    if (element.MappingId === 34) {
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity1Id,
                        StdMappingId: 34,
                      });
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity1Id,
                        StdMappingId: 48,
                      });
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity1Id,
                        StdMappingId: 49,
                      });
                    } else {
                      this.selectedScheduleEntityMappingIds.push({
                        EngagementId: this.engagementId,
                        ScheduleId: element.ScheduleId,
                        EntityId: entity.Entity1Id,
                        StdMappingId: element.MappingId,
                      });
                    }
                  } else {
                    this.selectedScheduleEntityMappingIds.push({
                      EngagementId: this.engagementId,
                      ScheduleId: element.ScheduleId,
                      EntityId: entity.Entity1Id,
                      StdMappingId: element.MappingId,
                    });
                  }
                }
              }
            }
          });
        }
      });

    // Check if only entities are selected then generate only entity - pl1 OR entity - bs1 schedule in index sheet.
    if (isAnyPLMappingSelected === false) {
      let scheduleId = 0;
      if (this.selectedTemplate === BusinessTemplate.Americas) {
        scheduleId = 2;
      } else if (this.selectedTemplate === BusinessTemplate.Row) {
        scheduleId = 8;
      } else if (this.selectedTemplate === BusinessTemplate.TotalCost) {
        scheduleId = 13;
      }

      this.plOnlyParentEntityData.forEach((entity) => {
        if (entity.Entity1IdIsChecked) {
          if (
            entity.Entity2Id !== null &&
            entity.Entity2Id !== undefined &&
            entity.Entity2Id !== 0
          ) {
            this.selectedScheduleEntityMappingIds.push({
              EngagementId: this.engagementId,
              ScheduleId: scheduleId,
              EntityId: entity.Entity2Id,
              StdMappingId: null,
            });
          } else {
            this.selectedScheduleEntityMappingIds.push({
              EngagementId: this.engagementId,
              ScheduleId: scheduleId,
              EntityId: entity.Entity1Id,
              StdMappingId: null,
            });
          }
        }
      });

      this.plOnlyEntityData.forEach((entity) => {
        if (entity.IsChecked) {
          if (
            entity.Entity2Id !== null &&
            entity.Entity2Id !== undefined &&
            entity.Entity2Id !== 0
          ) {
            if (
              !this.selectedScheduleEntityMappingIds.some(
                (x) =>
                  x.EntityId === entity.Entity2Id &&
                  (x.ScheduleId === 2 ||
                    x.ScheduleId === 8 ||
                    x.ScheduleId === 13) &&
                  x.StdMappingId === null
              )
            ) {
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: scheduleId,
                EntityId: entity.Entity2Id,
                StdMappingId: null,
              });
            }
          } else {
            if (
              !this.selectedScheduleEntityMappingIds.some(
                (x) =>
                  x.EntityId === entity.Entity1Id &&
                  (x.ScheduleId === 2 ||
                    x.ScheduleId === 8 ||
                    x.ScheduleId === 13) &&
                  x.StdMappingId === null
              )
            ) {
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: scheduleId,
                EntityId: entity.Entity1Id,
                StdMappingId: null,
              });
            }
          }
        }
      });
    }

    if (isAnyBSMappingSelected === false) {
      let scheduleId = 0;
      if (this.selectedTemplate === BusinessTemplate.Americas) {
        scheduleId = 3;
      } else if (this.selectedTemplate === BusinessTemplate.Row) {
        scheduleId = 9;
      } else if (this.selectedTemplate === BusinessTemplate.TotalCost) {
        scheduleId = 14;
      }

      this.bsOnlyParentEntityData.forEach((entity) => {
        if (entity.Entity1IdIsChecked) {
          if (
            entity.Entity2Id !== null &&
            entity.Entity2Id !== undefined &&
            entity.Entity2Id !== 0
          ) {
            this.selectedScheduleEntityMappingIds.push({
              EngagementId: this.engagementId,
              ScheduleId: scheduleId,
              EntityId: entity.Entity2Id,
              StdMappingId: null,
            });
          } else {
            this.selectedScheduleEntityMappingIds.push({
              EngagementId: this.engagementId,
              ScheduleId: scheduleId,
              EntityId: entity.Entity1Id,
              StdMappingId: null,
            });
          }
        }
      });

      this.bsOnlyEntityData.forEach((entity) => {
        if (entity.IsChecked) {
          if (
            entity.Entity2Id !== null &&
            entity.Entity2Id !== undefined &&
            entity.Entity2Id !== 0
          ) {
            if (
              !this.selectedScheduleEntityMappingIds.some(
                (x) =>
                  x.EntityId === entity.Entity2Id &&
                  (x.ScheduleId === 3 ||
                    x.ScheduleId === 9 ||
                    x.ScheduleId === 14) &&
                  x.StdMappingId === null
              )
            ) {
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: scheduleId,
                EntityId: entity.Entity2Id,
                StdMappingId: null,
              });
            }
          } else {
            if (
              !this.selectedScheduleEntityMappingIds.some(
                (x) =>
                  x.EntityId === entity.Entity1Id &&
                  (x.ScheduleId === 3 ||
                    x.ScheduleId === 9 ||
                    x.ScheduleId === 14) &&
                  x.StdMappingId === null
              )
            ) {
              this.selectedScheduleEntityMappingIds.push({
                EngagementId: this.engagementId,
                ScheduleId: scheduleId,
                EntityId: entity.Entity1Id,
                StdMappingId: null,
              });
            }
          }
        }
      });
    }

    switch (this.databookType) {
      case "pl1bs1":
        this.databookTypeValue = 1;
        break;
      case "datatab":
        this.databookTypeValue = 2;
        break;
      case "hardcoded":
        this.databookTypeValue = 3;
        break;
    }

    if (this.selectedEngagementSceduleIds.length !== 0) {
      this.savescheduleData = {
        EngagementId: this.engagementId,
        FromMonth: this.fromMonth,
        FromYear: +this.fromyear,
        ToMonth: this.toMonth,
        ToYear: +this.toyear,
        DatabookType: this.databookTypeValue,
        MappingLevel: this.mappingLevelId,
        DatabookVersion: this.versionType,
        SubSchedules: this.selectedEngagementSceduleIds,
        SchedulesEntityMappings: this.selectedScheduleEntityMappingIds,
        message: "",
        AccCalendarId: this.accountCalendarId,
        IsDynamicDatabook: this.isDynamicDatabook === "false" ? false : true,
        IsForecastIncl: this.isForecastAvailable == 1 ? true : false,
        ForecastMonth:
          this.isForecastAvailable == 1 ? this.fromForecastMonth : 0,
        ForecastYear: this.isForecastAvailable == 1 ? this.fromForecastYear : 0,
      };

      const scheduleUpdateData = {
        ...this.savescheduleData,
        AmountInMultiples: parseInt(this.amountInMultiples),
      };
      if (isDatabookUpload) {
        this.loadspinner_upload = true;
      } else {
        this.loadspinner = true;
      }
      this.periodService.IsPeriodMissing(this.savescheduleData).subscribe(
        (resp) => {
          if (!resp || isSavePowerBISchedule) {
            this.schedule
              .createEngagementSchedule(scheduleUpdateData)
              .subscribe(
                (response: SaveScheduleData) => {
                  if (response.message == "success") {
                    this.sharedService.setactiveindex(8);
                    if (!isSavePowerBISchedule) {
                      if (databookType == true) {
                        this.confirmgeneratedisplaydataTab = true;
                        this.loadspinner = false;
                        this.loadspinner_upload = false;
                      } else {
                        if (
                          this.versionType === DatabookVersionEnum.PowerPivot
                        ) {
                          this.updateDatabook(false);
                          this.selectedSceduleIds = [];
                        } else {
                          if (this.uploaddatabook == false) {
                            this.loadspinner = false;
                            this.loadspinner_upload = false;
                            this.confirmgeneratedisplay = true;
                            this.selectedSceduleIds = [];
                          } else {
                            this.updateDatabook(false);
                            this.selectedSceduleIds = [];
                          }
                        }
                      }
                    } else {
                      this.loadspinner = false;
                      this.loadspinner_upload = false;
                      this.downloadToPBIflatefile();
                    }
                  } else {
                    this.messageService.add({
                      key: this.currLangTranslation.severitymessage.key,
                      severity: severitymessage.error,
                      summary:
                        this.currLangTranslation.severitymessage.notification,
                      detail:
                        this.currLangTranslation.severitymessage.somethingwrong,
                      sticky: true,
                      closable: true,
                    });
                  }
                },
                (error) => {
                  this.loadspinner = false;
                  this.loadspinner_upload = false;
                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail: error.error.message,
                    sticky: true,
                    closable: true,
                  });
                }
              );
          } else {
            this.errorModel.confirmIsDisplay = true;
            this.errorModel.headerTitle =
              this.currLangTranslation.severitymessage.notification;
            this.errorModel.displayMessage =
              this.currLangTranslation.schedulesComponentmessage.ErrorMessage.MissingPeriodsP445;
            this.loadspinner = false;
            this.loadspinner_upload = false;
            return false;
          }
        },
        (error) => {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: error.error.message,
            sticky: true,
            closable: true,
          });
        }
      );
    }
  }

  ClickFinish() {
    this.loadspinner_data = true;
    this.schedule.updateIsFinishEngagement(this.engagementId).subscribe(
      (response: any) => {
        this.loadspinner_data = false;
        this.router.navigate(["/viewengagement/", this.engagementId]);
      },
      (error) => {
        this.loadspinner_data = false;
        this.logger.info(
          "--------error logged in schedules.component.ClickFinish()----------" +
          error
        );
      }
    );
  }

  //UpdateForecastDate() {
  //  this.loadspinner_data = true;
  //  this.schedule.updateForcastDetailsEngagement(this.engagementId, this.enableForecastDates, this.fromForecastMonth, this.fromForecastYear).subscribe((response: any) => {
  //    this.loadspinner_data = false;
  //    this.router.navigate(['/updateForcastDetailsEngagement/', this.engagementId, this.enableForecastDates, this.fromForecastMonth, this.fromForecastYear]);
  //  }, error => {
  //    this.loadspinner_data = false;
  //    this.logger.info('--------error logged in schedules.component.UpdateForecastDetails()----------' + error);
  //  });
  //}

  updateDatabook(generateTemplate) {
    let isNewVersion = true;
    isNewVersion =
      this.versionType === DatabookVersionEnum.Online ||
        this.versionType === DatabookVersionEnum.PowerPivot ||
        this.versionType === DatabookVersionEnum.Offline
        ? true
        : false;
    if (isNewVersion) {
      this.loadspinner = false;
    } else {
      this.loadspinner = true;
    }

    this.coverIndexService
      .GenerateDatabookToQueue(
        this.engagementId,
        this.versionType,
        generateTemplate
      )
      .subscribe(
        (data: any) => {
          if (data.status.indexOf("success") >= 0) {
            this.webJobQueueId = data.id;
            if (!isNewVersion) {
              this.checkDatabookGenerateProcessed();
            } else {
              this.notificationDisplay = true;
            }

            let databookTypeAuditText = this.databookType;
            switch (this.databookType) {
              case "pl1bs1":
                databookTypeAuditText = "PL1BS1";
                break;
              case "datatab":
                databookTypeAuditText = "DataTab";
                break;
              case "hardcoded":
                databookTypeAuditText = "Hardcoded";
                break;
            }

            let functionalityName = FunctionalityNames.OnlineDatabookGeneration;
            if (this.versionType === DatabookVersionEnum.Offline) {
              functionalityName = FunctionalityNames.OfflineDatabookGeneration;
              if (this.isDynamicDatabook === "true") {
                databookTypeAuditText = "Dynamic";
              }
            } else if (this.versionType === DatabookVersionEnum.PowerPivot) {
              functionalityName =
                FunctionalityNames.PowerPivotDatabookGeneration;
              //if (this.enableForecastDates == true && this.accountCalendarId == 1) {
              //  this.UpdateForecastDate();
              //}

              databookTypeAuditText = "";
            }
            const mappingLevelText =
              this.mappingLevelId === 8 ? "Standard" : "Custom";
            this.auditingService
              .addAudit(
                this.engagementId,
                functionalityName,
                databookTypeAuditText,
                mappingLevelText
              )
              .subscribe();
          } else {
            this.loadspinner = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (error) => {
          if (error.status === 400) {
            if (error.error.statusId === 422) {
              // 422 status id means queue is already present for flatfileupload
              this.errorModel.confirmIsDisplay = true;
              this.errorModel.headerTitle =
                this.currLangTranslation.severitymessage.notification;
              this.errorModel.displayMessage =
                this.currLangTranslation.schedulesComponentmessage.ErrorMessage.QueueInProgress;
              this.loadspinner = false;
              return false;
            }
          } else {
            this.logger.info(
              "--------error logged in schedules.component.updateDatabook()----------" +
              error
            );
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
            this.loadspinner = false;
          }
        }
      );
  }

  startStatusCheckTimer() {
    this.timeOutHandler = setInterval(() => {
      this.getDatabookstatus();
    }, environment.webjobTimer);
  }

  stopStatusCheckTimer() {
    clearInterval(this.timeOutHandler);
  }

  getEngagementDatabookData(version: number) {
    // version parameter is user has clicked on online button then if saved record for dynamic is offline then user is unable to select online option
    this.coverIndexService
      .getDatabookstatus(
        this.engagementId,
        this.isDynamicDatabook === "false" ? false : true
      )
      .subscribe(
        (data) => {
          this.databook = data;
          this.uploaddatabook = !(this.databook.length >= 1);
          if (this.databook.length > 0) {
            this.mappingLevelId = this.databook[0].MappingLevel;
            if (version === 0) {
              this.versionType = this.databook[0].DatabookVersion;
            }
            if (this.isDynamicDatabook === "true") {
              this.databookType = "datatab";
              this.disableDatabookType = true;
            } else {
              this.databookType = this.databook[0].DatabookDownloadType;
              this.disableDatabookType = false;
            }
            this.isLocalCopyUploaded = this.databook[0].IsLocalCopyUploaded;
            this.amountInMultiples = this.databook[0].AmountInMultiples;
          }
          this.getSchedules();
        },
        (error) => {
          this.logger.info(
            "--------error logged in schedules.component getEngagementDatabookData()----------" +
            error
          );
        }
      );
  }

  checkDatabookalreadyExists() {
    this.coverIndexService
      .getDatabookstatus(
        this.engagementId,
        this.isDynamicDatabook === "false" ? false : true
      )
      .subscribe(
        (data) => {
          this.databook = data;
          this.uploaddatabook = !(this.databook.length >= 1);
        },
        (error) => {
          this.logger.info(
            "--------error logged in schedules.component.checkDatabookalreadyExists()----------" +
            error
          );
        }
      );
  }

  getDatabookstatus() {
    this.coverIndexService
      .getDatabookstatus(
        this.engagementId,
        this.isDynamicDatabook === "false" ? false : true
      )
      .subscribe(
        (data) => {
          this.databook = data;
          if (this.databook.length >= 1) {
            this.databook = data[0];
            if (
              this.databook.IsProcessed &&
              !this.databook.IsQueued &&
              this.databook.DataBookName.length > 0
            ) {
              this.stopStatusCheckTimer();
              this.downloadDatabook();
            }
          } else {
            this.stopStatusCheckTimer();
          }
        },
        (error) => {
          this.logger.info(
            "--------error logged in schedules.component.getDatabookstatus()----------" +
            error
          );
        }
      );
  }

  downloadDatabook() {
    let isNewVersion = true;
    isNewVersion =
      this.versionType === DatabookVersionEnum.Online ? true : false;
    if (!isNewVersion) {
      let apiService;
      if (this.versionType === DatabookVersionEnum.Offline) {
        apiService = this.coverIndexService.downloadDatabookFromBlob(
          this.engagementId
        );
      } else {
        apiService = this.coverIndexService.downloadPowerPivotDatabookFromBlob(
          this.engagementId
        );
      }

      apiService.subscribe(
        (blobdata) => {
          this.loadspinner = false;
          if (!this.downloadDatabookWithPrompt) {
            this.coverIndexService
              .getDatabookstatus(
                this.engagementId,
                this.isDynamicDatabook === "false" ? false : true
              )
              .subscribe(
                (data) => {
                  this.databook = data;
                  this.uploaddatabook = !(this.databook.length >= 1);
                  const databookIndex =
                    this.databook[0].DataBookName.lastIndexOf("\\");
                  let fileName = this.databook[0].DataBookName.substr(
                    databookIndex + 1
                  );
                  if (this.versionType === DatabookVersionEnum.PowerPivot) {
                    const today = new Date();
                    let todayDateString;
                    let downloadFileName =
                      this.databook[0].EngagementName + "_Databook_";
                    if (
                      this.databook[0].TemplateId === BusinessTemplate.Americas
                    ) {
                      todayDateString =
                        ("0" + (today.getMonth() + 1)).slice(-2) +
                        ("0" + today.getDate()).slice(-2) +
                        today.getFullYear();
                      downloadFileName += `${todayDateString}.zip`;
                    } else {
                      todayDateString =
                        ("0" + today.getDate()).slice(-2) +
                        ("0" + (today.getMonth() + 1)).slice(-2) +
                        today.getFullYear();
                      downloadFileName += `${todayDateString}.zip`;
                    }
                    fileName = downloadFileName;
                  }
                  if (blobdata) {
                    saveAs(blobdata, fileName);
                  }
                  event.stopPropagation();
                  this.downloadenable = false;
                  return;
                },
                (error) => {
                  this.logger.info(
                    "--------error logged in schedules.component getDatabookstatus()----------" +
                    error
                  );
                }
              );
          }

          this.confirmationService.confirm({
            message:
              this.currLangTranslation.schedulesComponentmessage.ConfirmMessage
                .ConfirmDatabook,
            header: this.currLangTranslation.labels.warning,
            acceptLabel: this.currLangTranslation.actionButtons.yes,
            rejectLabel: this.currLangTranslation.actionButtons.no,
            accept: () => {
              window.location.href = this.configUrl;
              event.stopPropagation();
              this.downloadenable = false;
              return;
            },
            reject: () => { },
          });
        },
        (error) => {
          this.logger.info(
            "--------error logged in schedules.component.downloadDatabook()----------" +
            error
          );
          this.loadspinner = false;
          this.downloadenable = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.DownloadError,
            sticky: true,
            closable: true,
          });
        }
      );
    } else {
      this.loadspinner = false;
    }
  }

  downloadUploadDatabook() {
    let isNewVersion = true;
    isNewVersion =
      this.versionType === DatabookVersionEnum.Online ? true : false;
    if (!isNewVersion) {
      this.coverIndexService
        .downloadDatabookFromBlob(this.engagementId)
        .subscribe(
          (blobdata) => {
            this.loadspinner = false;
            if (!this.downloadDatabookWithPrompt) {
              this.coverIndexService
                .getDatabookstatus(
                  this.engagementId,
                  this.isDynamicDatabook === "false" ? false : true
                )
                .subscribe(
                  (data) => {
                    this.databook = data;
                    this.uploaddatabook = !(this.databook.length >= 1);
                    const databookIndex =
                      this.databook[0].DataBookName.lastIndexOf("\\");
                    const fileName = this.databook[0].DataBookName.substr(
                      databookIndex + 1
                    );
                    if (blobdata) {
                      saveAs(blobdata, fileName);
                    }
                    event.stopPropagation();
                    this.downloadenable = false;
                    return;
                  },
                  (error) => {
                    this.logger.info(
                      "--------error logged in schedules.component getDatabookstatus()----------" +
                      error
                    );
                  }
                );
            }
          },
          (error) => {
            this.logger.info(
              "--------error logged in schedules.component.downloadDatabook()----------" +
              error
            );
            this.loadspinner = false;
            this.downloadenable = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.DownloadError,
              sticky: true,
              closable: true,
            });
          }
        );
    } else {
      this.loadspinner = false;
    }
  }

  downloadToflatefile() {
    this.loadspinnerflatfile = true;
    // Add into Queue
    this.flatfileService
      .addFlatFileDownloadIntoQueue(this.engagementId)
      .subscribe((queueId: any) => {
        this.auditingService
          .addAudit(this.engagementId, FunctionalityNames.FlatFileDownload)
          .subscribe();
        this.flatFileDownloadWebJobQueueId = queueId.id;
        this.checkFlatFileDownloadProcessed();
      });
  }

  checkFlatFileDownloadProcessed() {
    this.webJobQueueService
      .getWebJobQueue(this.flatFileDownloadWebJobQueueId)
      .subscribe(
        (resp: WebJobQueueModel) => {
          if (resp) {
            if (!resp.isQueued) {
              this.isTimeIntervalInProgressFlatFileDownload = false;
              clearInterval(this.timeOutHandlerFlatFileDownload);
              if (resp.isError) {
                this.loadspinnerflatfile = false;
                if (resp.responseText === "") {
                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail:
                      this.currLangTranslation.severitymessage.somethingwrong,
                    sticky: true,
                    closable: true,
                  });
                } else {
                  this.errorModel.confirmIsDisplay = true;
                  this.errorModel.displayMessage = resp.responseText;
                }
              } else {
                this.downloadFlatFile();
              }
            } else {
              if (!this.isTimeIntervalInProgressFlatFileDownload) {
                this.timeOutHandlerFlatFileDownload = setInterval(() => {
                  this.isTimeIntervalInProgressFlatFileDownload = true;
                  this.loadspinnerflatfile = true;
                  this.checkFlatFileDownloadProcessed();
                }, environment.webjobTimer);
              }
            }
          } else {
            this.loadspinnerflatfile = false;
            this.isTimeIntervalInProgressFlatFileDownload = false;
            clearInterval(this.timeOutHandlerFlatFileDownload);
          }
        },
        (err) => {
          this.loadspinnerflatfile = false;
          this.isTimeIntervalInProgressFlatFileDownload = false;
          clearInterval(this.timeOutHandlerFlatFileDownload);
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  downloadFlatFile() {
    this.loadspinnerflatfile = true;
    this.flatfileName = this.engagementName;
    const today = new Date();
    let todayDateString;

    if (this.regionId == RegionsEnum.US) {
      todayDateString =
        ("0" + (today.getMonth() + 1)).slice(-2) +
        ("0" + today.getDate()).slice(-2) +
        today.getFullYear();
      this.flatfileName += "_FlatFile_" + `${todayDateString}.xlsx`;
    } else {
      todayDateString =
        ("0" + today.getDate()).slice(-2) +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        today.getFullYear();
      this.flatfileName += "_FlatFile_" + `${todayDateString}.xlsx`;
    }

    this.flatfileService
      .getflatfile(this.flatFileDownloadWebJobQueueId)
      .subscribe(
        (blobData) => {
          this.loadspinnerflatfile = false;
          if (blobData) {
            saveAs(blobData, this.flatfileName);
          } else {
            this.loadspinnerflatfile = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (err) => {
          this.loadspinnerflatfile = false;

          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  downloadToPBIflatefile() {
    this.loadspinnerPBIflatfile = true;
    // Add into Queue
    this.flatfileService
      .addPowerBIFlatFileDownloadIntoQueue(this.engagementId)
      .subscribe((queueId: any) => {
        this.powerBiflatFileDownloadWebJobQueueId = queueId.id;
        this.checkPowerBIFlatFileDownloadProcessed();
      });
    this.auditingService
      .addAudit(this.engagementId, FunctionalityNames.PowerBIFlatFile)
      .subscribe();
  }

  checkPowerBIFlatFileDownloadProcessed() {
    this.webJobQueueService
      .getWebJobQueue(this.powerBiflatFileDownloadWebJobQueueId)
      .subscribe(
        (resp: WebJobQueueModel) => {
          if (resp) {
            if (!resp.isQueued) {
              this.isTimeIntervalInProgressPowerBiFlatFileDownload = false;
              clearInterval(this.timeOutHandlerPowerBiFlatFileDownload);
              if (resp.isError) {
                this.loadspinnerPBIflatfile = false;
                if (resp.responseText === "") {
                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail:
                      this.currLangTranslation.severitymessage.somethingwrong,
                    sticky: true,
                    closable: true,
                  });
                } else {
                  this.errorModel.confirmIsDisplay = true;
                  this.errorModel.displayMessage = resp.responseText;
                }
              } else {
                this.downloadPowerBiFlatFile();
              }
            } else {
              if (!this.isTimeIntervalInProgressPowerBiFlatFileDownload) {
                this.timeOutHandlerPowerBiFlatFileDownload = setInterval(() => {
                  this.isTimeIntervalInProgressPowerBiFlatFileDownload = true;
                  this.loadspinnerPBIflatfile = true;
                  this.checkPowerBIFlatFileDownloadProcessed();
                }, environment.webjobTimer);
              }
            }
          } else {
            this.loadspinnerPBIflatfile = false;
            this.isTimeIntervalInProgressPowerBiFlatFileDownload = false;
            clearInterval(this.timeOutHandlerPowerBiFlatFileDownload);
          }
        },
        (err) => {
          this.loadspinnerPBIflatfile = false;
          this.isTimeIntervalInProgressPowerBiFlatFileDownload = false;
          clearInterval(this.timeOutHandlerPowerBiFlatFileDownload);
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  downloadPowerBiFlatFile() {
    this.loadspinnerPBIflatfile = true;
    this.flatfileName = this.engagementName;
    const today = new Date();
    let todayDateString;

    if (this.regionId == RegionsEnum.US) {
      todayDateString =
        ("0" + (today.getMonth() + 1)).slice(-2) +
        ("0" + today.getDate()).slice(-2) +
        today.getFullYear();
      this.flatfileName += "_PowerBIFlatFile_" + `${todayDateString}.xlsx`;
    } else {
      todayDateString =
        ("0" + today.getDate()).slice(-2) +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        today.getFullYear();
      this.flatfileName += "_PowerBIFlatFile_" + `${todayDateString}.xlsx`;
    }

    this.flatfileService
      .getPowerBiflatfile(this.powerBiflatFileDownloadWebJobQueueId)
      .subscribe(
        (blobData) => {
          this.loadspinnerPBIflatfile = false;
          if (blobData) {
            saveAs(blobData, this.flatfileName);
            this.downloadPBIXTemplate();
          } else {
            this.loadspinnerPBIflatfile = false;

            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (err) => {
          this.loadspinnerPBIflatfile = false;

          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  downloadDaiseyDashboard() {
    this.updateCoverIndex(false, true);
    this.isGenDatabookInProgress = false;
  }

  downloadPBIXTemplate() {
    this.loadspinnerdaiseydashboard = true;
    this.daiseyDashboardName = this.engagementName;
    const today = new Date();
    let todayDateString;
    // ProjectName_PBIdashboard_mmddyyyy.pbix (for US)
    // ProjectName_PBIdashboard_ddmmyyyy.pbix (for ROW)

    if (this.regionId == RegionsEnum.US) {
      todayDateString =
        ("0" + (today.getMonth() + 1)).slice(-2) +
        ("0" + today.getDate()).slice(-2) +
        today.getFullYear();
      this.daiseyDashboardName += "_PBIdashboard_" + `${todayDateString}.pbit`;
    } else {
      todayDateString =
        ("0" + today.getDate()).slice(-2) +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        today.getFullYear();
      this.daiseyDashboardName += "_PBIdashboard_" + `${todayDateString}.pbit`;
    }
    this.daisedashboard
      .getDaisedashboardTemplate(
        this.engagementId,
        this.accountCalendarId,
        this.selectedTemplate
      )
      .subscribe(
        (blobData) => {
          this.loadspinnerdaiseydashboard = false;
          if (blobData) {
            saveAs(blobData, this.daiseyDashboardName);
          } else {
            this.loadspinnerdaiseydashboard = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (error) => {
          this.logger.info(
            "--------error logged in schedules.component.downloadDaiseyDashboard()----------" +
            error
          );
          this.loadspinnerdaiseydashboard = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  private checkDatabookGenerateProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe(
      (resp: WebJobQueueModel) => {
        if (resp) {
          if (!resp.isQueued) {
            this.isTimeIntervalInProgress = false;
            clearInterval(this.timeOutHandler);
            if (resp.isError) {
              this.loadspinner = false;
              if (resp.responseText === "") {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              }
            } else {
              this.downloadDatabook();
            }
          } else {
            if (!this.isTimeIntervalInProgress) {
              this.timeOutHandler = setInterval(() => {
                this.isTimeIntervalInProgress = true;
                this.loadspinner = true;
                this.checkDatabookGenerateProcessed();
              }, environment.webjobTimer);
            }
          }
        } else {
          this.loadspinner = false;
          this.isTimeIntervalInProgress = false;
          clearInterval(this.timeOutHandler);
        }
      },
      (err) => {
        this.loadspinner = false;
        this.isTimeIntervalInProgress = false;
        clearInterval(this.timeOutHandler);
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  OkNotificationDisplay() {
    this.notificationDisplay = false;
  }

  onDateChange() {
    //alert(this.fromForecastMonths);

    if (
      this.enableForecastDates &&
      this.versionType == DatabookVersionEnum.PowerPivot
    ) {
      this.onFYChange();
    }
    if (
      this.fromMonth == null ||
      this.fromMonth == 0 ||
      this.fromyear == "null" ||
      this.fromyear == "" ||
      this.toMonth == null ||
      this.toMonth == 0 ||
      this.toyear == "null" ||
      this.toyear == ""
    ) {
      this.loadspinner_data = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage
            .Mandatory,
        sticky: true,
        closable: true,
      });
      return false;
    }
    if (this.fromyear > this.toyear) {
      this.loadspinner_data = false;
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key,
        severity: severitymessage.error,
        summary: this.currLangTranslation.severitymessage.notification,
        detail:
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage
            .YearError,
        sticky: true,
        closable: true,
      });
      return false;
    }
    if (this.fromyear == this.toyear) {
      if (this.fromMonth > this.toMonth) {
        this.loadspinner_data = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail:
            this.currLangTranslation.schedulesComponentmessage.ErrorMessage
              .MonthError,
          sticky: true,
          closable: true,
        });
        return false;
      }
    }
    if (
      this.accountCalendarId === AccountingCalendarEnum.P12 ||
      this.accountCalendarId === AccountingCalendarEnum.P445 ||
      this.accountCalendarId === AccountingCalendarEnum.P454 ||
      this.accountCalendarId === AccountingCalendarEnum.P544
    ) {
      if (
        (this.toyear - this.fromyear) * 12 +
        (this.toMonth - this.fromMonth + 1) <
        12
      ) {
        this.loadspinner_data = false;
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage.LessThan12MonthError;
        return false;
      }
    } else if (this.accountCalendarId === AccountingCalendarEnum.P13) {
      if (
        (this.toyear - this.fromyear) * 13 +
        (this.toMonth - this.fromMonth + 1) <
        13
      ) {
        this.loadspinner_data = false;
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.schedulesComponentmessage.ErrorMessage.LessThan13MonthError;
        return false;
      }
    }
    this.getSchedules();
  }

  mappingAccordian(event) {
    const element = event.target;
    element.classList.toggle("active");
    const panel = element.nextElementSibling;
    if (panel.classList.contains("no-max-height")) {
      panel.classList.remove("no-max-height");
      panel.classList.add("max-height-inherit");
    } else {
      panel.classList.remove("max-height-inherit");
      panel.classList.add("no-max-height");
    }
  }

  mappingChildAccordian(event) {
    const element = event.target;
    element.classList.toggle("active");
    const panel = element.nextElementSibling;
    if (panel.classList.contains("no-max-height")) {
      panel.classList.remove("no-max-height");
      panel.classList.add("max-height-inherit");
    } else {
      panel.classList.remove("max-height-inherit");
      panel.classList.add("no-max-height");
    }
  }

  scheduleCheckChanges(scheduleId: any, event: any) {
    if (scheduleId === 2 || scheduleId === 8 || scheduleId === 13) {
      // If PL Schedule checkbox is selected/unselected then select/unselect all child items.
      const plEntityWiseCheckbox = document.getElementById(
        "chkPLEntityWise"
      ) as HTMLFormElement;
      const plMappingWiseCheckbox = document.getElementById(
        "chkPLMppingSchedules"
      ) as HTMLFormElement;

      if (event.currentTarget.checked) {
        if (
          plEntityWiseCheckbox !== undefined &&
          plEntityWiseCheckbox !== null
        ) {
          plEntityWiseCheckbox.checked = true;
        }

        plMappingWiseCheckbox.checked = true;
        // Check with PL child items.
        this.plMappingData.forEach((element) => {
          if (
            element.IsMappingSelected === true ||
            element.IsMappingSelected === 1
          ) {
            element.IsChecked = true;
          }
          if (this.isDynamicDatabook === "true") {
            element.IsChecked = false;
          }
        });

        // Select all PL entities
        this.plOnlyEntityData.forEach((element) => {
          element.IsChecked = true;
        });

        this.plOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = true;
        });
      } else if (!event.currentTarget.checked) {
        // If PL schedule checkbox is unselected then unselect all child items and unselect QE- Lead quality of earnings and Lead PF-PL
        if (
          plEntityWiseCheckbox !== undefined &&
          plEntityWiseCheckbox !== null
        ) {
          plEntityWiseCheckbox.checked = false;
        }

        plMappingWiseCheckbox.checked = false;
        // Check with PL child items.
        this.plMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = false;
          }
        });

        // UnSelect all PL entities
        this.plOnlyEntityData.forEach((element) => {
          element.IsChecked = false;
        });

        this.plOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = false;
        });

        this.files.filter((r) => {
          if (r.Id === 1 || r.Id === 7 || r.Id === 6 || r.Id === 12) {
            // QE- Lead quality of earnings and Lead PF-PL
            r.isChecked = false;
          }
        });
      }
    }

    if (scheduleId === 3 || scheduleId === 9 || scheduleId === 14) {
      const bsEntityWiseCheckbox = document.getElementById(
        "chkBSEntityWise"
      ) as HTMLFormElement;
      const bsMappingWiseCheckbox = document.getElementById(
        "chkBSMppingSchedules"
      ) as HTMLFormElement;

      if (event.currentTarget.checked) {
        if (
          bsEntityWiseCheckbox !== undefined &&
          bsEntityWiseCheckbox !== null
        ) {
          bsEntityWiseCheckbox.checked = true;
        }

        bsMappingWiseCheckbox.checked = true;
        // Check with BS child items.
        this.bsMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = true;
          }
        });

        // Select all BS entities
        this.bsOnlyEntityData.forEach((element) => {
          element.IsChecked = true;
        });

        this.bsOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = true;
        });
      } else if (!event.currentTarget.checked) {
        if (
          bsEntityWiseCheckbox !== undefined &&
          bsEntityWiseCheckbox !== null
        ) {
          bsEntityWiseCheckbox.checked = false;
        }

        bsMappingWiseCheckbox.checked = false;
        // Check with BS child items.
        this.bsMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = false;
          }
        });

        // Unselect all BS entities
        this.bsOnlyEntityData.forEach((element) => {
          element.IsChecked = false;
        });

        this.bsOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = false;
        });

        this.files.filter((r) => {
          if (
            r.Id === 4 ||
            r.Id === 10 ||
            r.Id === 5 ||
            r.Id === 11 ||
            r.Id === 15 ||
            r.Id === 16
          ) {
            // WC - Working capital and CF - Free cash flow
            r.isChecked = false;
          }
        });
      }
    }

    if (
      scheduleId === 1 ||
      scheduleId === 7 ||
      scheduleId === 6 ||
      scheduleId === 12
    ) {
      // If QE- Lead quality of earnings OR Lead PF-PL selected then select PL Schedule
      if (event.currentTarget.checked) {
        this.files.filter((r) => {
          if (
            r.Id === 2 ||
            r.Id === 8 ||
            r.Id === 13 ||
            (scheduleId === 6 &&
              r.Id === 1 &&
              this.selectedTemplate === BusinessTemplate.Americas)
          ) {
            // PL Schedule
            r.isChecked = true;
          }
        });
      } else if (!event.currentTarget.checked) {
        this.files.filter((r) => {
          if (
            scheduleId === 1 &&
            r.Id === 6 &&
            this.selectedTemplate === BusinessTemplate.Americas
          ) {
            // Remove PF-PL when QE Unchecked for only Americas Template
            r.isChecked = false;
          }
        });
      }
    }

    if (
      scheduleId === 4 ||
      scheduleId === 10 ||
      scheduleId === 5 ||
      scheduleId === 11 ||
      scheduleId === 15 ||
      scheduleId === 16
    ) {
      // If Working Capital WC OR Cash Flow CF selected then select BS Schedule
      if (event.currentTarget.checked) {
        this.files.filter((r) => {
          if (r.Id === 3 || r.Id === 9 || r.Id === 14) {
            // BS Schedule
            r.isChecked = true;
          }
        });
      }
    }
  }

  entityWiseCheckChanges(scheduleId: any, event: any) {
    if (scheduleId === 2 || scheduleId === 8 || scheduleId === 13) {
      // If PL Schedule checkbox is selected/unselected then select/unselect all child items.
      if (event.currentTarget.checked) {
        // Select all PL entities
        this.plOnlyEntityData.forEach((element) => {
          element.IsChecked = true;
        });

        this.plOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = true;
        });

        this.files.filter((r) => {
          if (r.Id === 2 || r.Id === 8 || r.Id === 13) {
            // PL Schedule
            r.isChecked = true;
          }
        });
      } else {
        // UnSelect all PL entities
        this.plOnlyEntityData.forEach((element) => {
          element.IsChecked = false;
        });

        this.plOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = false;
        });
      }
    } else if (scheduleId === 3 || scheduleId === 9 || scheduleId === 14) {
      // If BS Schedule checkbox is selected/unselected then select/unselect all child items.
      if (event.currentTarget.checked) {
        // Select all BS entities
        this.bsOnlyEntityData.forEach((element) => {
          element.IsChecked = true;
        });

        this.bsOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = true;
        });

        this.files.filter((r) => {
          if (r.Id === 3 || r.Id === 9 || r.Id === 14) {
            // BS Schedule
            r.isChecked = true;
          }
        });
      } else {
        // UnSelect all BS entities
        this.bsOnlyEntityData.forEach((element) => {
          element.IsChecked = false;
        });

        this.bsOnlyParentEntityData.forEach((element) => {
          element.Entity1IdIsChecked = false;
        });
      }
    }
  }

  mappingWiseCheckChanges(scheduleId: any, event: any) {
    if (scheduleId === 2 || scheduleId === 8 || scheduleId === 13) {
      // If PL Schedule checkbox is selected/unselected then select/unselect all child items.
      if (event.currentTarget.checked) {
        // Check with PL child items.
        this.plMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = true;
          }
        });

        this.files.filter((r) => {
          if (r.Id === 2 || r.Id === 8 || r.Id === 13) {
            // PL Schedule
            r.isChecked = true;
          }
        });
      } else {
        // Check with PL child items.
        this.plMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = false;
          }
        });
      }
    } else if (scheduleId === 3 || scheduleId === 9 || scheduleId === 14) {
      // If BS Schedule checkbox is selected/unselected then select/unselect all child items.
      if (event.currentTarget.checked) {
        // Check with BS child items.
        this.bsMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = true;
          }
        });

        this.files.filter((r) => {
          if (r.Id === 3 || r.Id === 9 || r.Id === 14) {
            // BS Schedule
            r.isChecked = true;
          }
        });
      } else {
        // Check with BS child items.
        this.bsMappingData.forEach((element) => {
          if (element.IsMappingSelected || element.IsMappingSelected === 1) {
            element.IsChecked = false;
          }
        });
      }
    }
  }

  childMappingCheckChanges(scheduleId: any, event: any) {
    if (scheduleId === 2 || scheduleId === 8 || scheduleId === 13) {
      // If PL Mappiong checkbox is selected/unselected then select parent items.
      if (event.currentTarget.checked) {
        const plMappingWiseCheckbox = document.getElementById(
          "chkPLMppingSchedules"
        ) as HTMLFormElement;
        plMappingWiseCheckbox.checked = true;
        this.isPLMappingOptionSelected = true;
        this.files.filter((r) => {
          if (r.Id === 2 || r.Id === 8 || r.Id === 13) {
            // PL Schedule
            r.isChecked = true;
          }
        });
      }
    } else if (scheduleId === 3 || scheduleId === 9 || scheduleId === 14) {
      // If BS Schedule checkbox is selected/unselected then select/unselect all child items.
      if (event.currentTarget.checked) {
        const bsMappingWiseCheckbox = document.getElementById(
          "chkBSMppingSchedules"
        ) as HTMLFormElement;
        bsMappingWiseCheckbox.checked = true;
        this.isBSMappingOptionSelected = true;
        this.files.filter((r) => {
          if (r.Id === 3 || r.Id === 9 || r.Id === 14) {
            // BS Schedule
            r.isChecked = true;
          }
        });
      }
    }
  }

  childEntityCheckChanges(scheduleId: any, entity1Id: any, event: any) {
    if (scheduleId === 2 || scheduleId === 8 || scheduleId === 13) {
      // If PL Entity checkbox is selected/unselected then select parent items.
      if (event.currentTarget.checked) {
        const plEntityWiseCheckbox = document.getElementById(
          "chkPLEntityWise"
        ) as HTMLFormElement;
        if (
          plEntityWiseCheckbox !== undefined &&
          plEntityWiseCheckbox !== null
        ) {
          plEntityWiseCheckbox.checked = true;
        }

        this.isPLEntityOptionSelected = true;
        this.files.filter((r) => {
          if (r.Id === 2 || r.Id === 8 || r.Id === 13) {
            // PL Schedule
            r.isChecked = true;
          }
        });

        this.plOnlyParentEntityData.forEach((element) => {
          if (element.Entity1Id === entity1Id) {
            element.Entity1IdIsChecked = true;
          }
        });
      }
    } else if (scheduleId === 3 || scheduleId === 9 || scheduleId === 14) {
      // If BS Entity checkbox is selected/unselected then select/unselect all child items.
      if (event.currentTarget.checked) {
        const bsEntityWiseCheckbox = document.getElementById(
          "chkBSEntityWise"
        ) as HTMLFormElement;
        if (
          bsEntityWiseCheckbox !== undefined &&
          bsEntityWiseCheckbox !== null
        ) {
          bsEntityWiseCheckbox.checked = true;
        }
        this.isBSEntityOptionSelected = true;
        this.files.filter((r) => {
          if (r.Id === 3 || r.Id === 9 || r.Id === 14) {
            // BS Schedule
            r.isChecked = true;
          }
        });

        this.bsOnlyParentEntityData.forEach((element) => {
          if (element.Entity1Id === entity1Id) {
            element.Entity1IdIsChecked = true;
          }
        });
      }
    }
  }

  childParentEntityCheckChanges(scheduleId: any, entity1Id: any, event: any) {
    if (scheduleId === 2 || scheduleId === 8 || scheduleId === 13) {
      // If PL Entity checkbox is selected/unselected then select parent items.
      if (event.currentTarget.checked) {
        const plEntityWiseCheckbox = document.getElementById(
          "chkPLEntityWise"
        ) as HTMLFormElement;
        if (
          plEntityWiseCheckbox !== undefined &&
          plEntityWiseCheckbox !== null
        ) {
          plEntityWiseCheckbox.checked = true;
        }
        this.isPLEntityOptionSelected = true;
        this.files.filter((r) => {
          if (r.Id === 2 || r.Id === 8 || r.Id === 13) {
            // PL Schedule
            r.isChecked = true;
          }
        });

        this.plOnlyEntityData.forEach((element) => {
          if (element.Entity1Id === entity1Id) {
            element.IsChecked = true;
          }
        });
      } else {
        this.plOnlyEntityData.forEach((element) => {
          if (element.Entity1Id === entity1Id) {
            element.IsChecked = false;
          }
        });
      }
    } else if (scheduleId === 3 || scheduleId === 9 || scheduleId === 14) {
      // If BS Entity checkbox is selected/unselected then select/unselect all child items. test
      if (event.currentTarget.checked) {
        const bsEntityWiseCheckbox = document.getElementById(
          "chkBSEntityWise"
        ) as HTMLFormElement;
        if (
          bsEntityWiseCheckbox !== undefined &&
          bsEntityWiseCheckbox !== null
        ) {
          bsEntityWiseCheckbox.checked = true;
        }

        this.isBSEntityOptionSelected = true;
        this.files.filter((r) => {
          if (r.Id === 3 || r.Id === 9 || r.Id === 14) {
            // BS Schedule
            r.isChecked = true;
          }
        });

        this.bsOnlyEntityData.forEach((element) => {
          if (element.Entity1Id === entity1Id) {
            element.IsChecked = true;
          }
        });
      } else {
        this.bsOnlyEntityData.forEach((element) => {
          if (element.Entity1Id === entity1Id) {
            element.IsChecked = false;
          }
        });
      }
    }
  }

  onOnlineOfflineSelection() {
    this.versionType = parseInt(this.versionType.toString());

    this.onFYChange();

    if (this.versionType === DatabookVersionEnum.Online) {
      this.isDynamicDatabook = "false";
      this.disableDatabookType = false;
      this.displayForecastPeriod = false;
      if (this.displayStaticDynamicSelection) {
        this.getEngagementDatabookData(1);
      }
    }
    if (
      this.engagementData.LanguageId === DatabookLanguage.SpanishLatinAmerica ||
      (this.engagementData.LanguageId === DatabookLanguage.Japanese &&
        this.regionId === RegionsEnum.APAC)
    ) {
      this.disablePowerPivotUpload = false;
      this.disableOfflineUploadForSpanish = true;
      this.disableOfflineForNonEnglish = true;
      this.displayTypeOfDatabook = true;
      // this.displayForecastPeriod = false;
    }

    if (this.versionType === DatabookVersionEnum.PowerPivot) {
      this.isDynamicDatabook = "false";
      this.disablePowerPivotUpload = true;
      this.displayTypeOfDatabook = false;
      if (this.accountCalendarId == 1) {
        this.displayForecastPeriod = true;
      }

      this.disableOfflineUploadForSpanish = false;
    } else if (this.versionType === DatabookVersionEnum.Online) {
      this.disableOfflineUploadForSpanish = false;
      this.disablePowerPivotUpload = false;
      this.displayTypeOfDatabook = true;
      this.displayForecastPeriod = false;
    } else {
      this.disableOfflineUploadForSpanish = false;
      this.disablePowerPivotUpload = false;
      this.displayTypeOfDatabook = true;
      this.displayForecastPeriod = false;
      this.databookType = "datatab";
    }
  }

  onStaticDynamicSelection() {
    if (this.isDynamicDatabook === "true") {
      this.databookType = "datatab";
      this.disableDatabookType = true;
    } else {
      this.disableDatabookType = false;
    }

    this.getEngagementDatabookData(0);
  }

  resetDatabook() {
    this.confirmationService.confirm({
      message:
        '<div class="scheduleconfirmation">' +
        this.currLangTranslation.step8.messages.confirmReset +
        "</div>",
      header: this.currLangTranslation.labels.confirmation,
      acceptLabel: this.currLangTranslation.actionButtons.yes,
      rejectLabel: this.currLangTranslation.actionButtons.no,
      accept: () => {
        this.loadspinner_data = true;
        this.schedule.resetDatabook(this.engagementId).subscribe(
          (response: any) => {
            this.loadspinner_data = false;
            if (response.message === "success") {
              this.LoadData();
              this.displayTypeOfDatabook = true;
              this.displayForecastPeriod = false;
              this.disableGenerateButton = false;

              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.success,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.step8.messages.resetDatabook,
                sticky: true,
                closable: true,
              });
            } else {
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          },
          (error) => {
            this.loadspinner_data = false;
            if (error.status === 400 && error.error.statusId === 422) {
              // 422 status id means queue is already present for databook generation
              this.errorModel.confirmIsDisplay = true;
              this.errorModel.headerTitle =
                this.currLangTranslation.severitymessage.notification;
              this.errorModel.displayMessage =
                this.currLangTranslation.schedulesComponentmessage.ErrorMessage.QueueInProgress;
              return false;
            } else {
              this.messageService.add({
                key: severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          }
        );
        this.auditingService
          .addAudit(this.engagementId, FunctionalityNames.ResetDatabook)
          .subscribe();
      },
      reject: () => { },
    });
  }
}
